<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow
          v-if="structure.id"
          :confirm="askConfirm"
          routeBack="StructureIndex"
          :title="$t('Modify') + ' ' + $t('a.e')  + ' ' +  $t('structure')"/>
        <back-arrow
          v-else
          :confirm="askConfirm"
          routeBack="StructureIndex"
          :title="$t('Add') + ' ' + $t('a.e')  + ' ' +  $t('structure')"/>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm card-scrollable">
            <b-form @submit.stop.prevent="onSubmit">

              <div class="row">
                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.structureName.invalidFeedback"
                    :label="$t('structure.name')"
                    :state="form.structureName.state"
                    class="medium-label mb-4 required-input"
                    label-for="addressDetails-input">
                    <b-form-input
                      id="addressDetails-input"
                      v-model="form.structureName.value"
                      :state="form.structureName.state"
                      required
                      tabindex="1"
                      v-on:change="removeInvalidFeedback('structureName'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.address.invalidFeedback"
                    :label="$t('structure.address')"
                    :state="form.address.state"
                    class="medium-label mb-4 required-input"
                    label-for="address-input">
                    <b-form-input
                      id="address-input"
                      v-model="form.address.value"
                      :state="form.address.state"
                      required
                      tabindex="2"
                      v-on:change="removeInvalidFeedback('address'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.addressDetails.invalidFeedback"
                    :label="$t('structure.address.details')"
                    :state="form.addressDetails.state"
                    class="medium-label mb-4"
                    label-for="addressDetails-input">
                    <b-form-input
                      id="addressDetails-input"
                      v-model="form.addressDetails.value"
                      :state="form.addressDetails.state"
                      tabindex="3"
                      v-on:change="removeInvalidFeedback('addressDetails'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.postalCode.invalidFeedback"
                    :label="$t('structure.postalCode')"
                    :state="form.postalCode.state"
                    class="medium-label mb-4 required-input"
                    label-for="addressDetails-input">
                    <b-form-input
                      id="addressDetails-input"
                      v-model="form.postalCode.value"
                      :state="form.postalCode.state"
                      required
                      tabindex="4"
                      v-on:change="removeInvalidFeedback('postalCode'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.city.invalidFeedback"
                    :label="$t('structure.city')"
                    :state="form.city.state"
                    class="medium-label mb-4 required-input"
                    label-for="addressDetails-input">
                    <b-form-input
                      id="addressDetails-input"
                      v-model="form.city.value"
                      :state="form.city.state"
                      required
                      tabindex="5"
                      v-on:change="removeInvalidFeedback('city'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.lastName.invalidFeedback"
                    :label="$t('structure.lastName')"
                    :state="form.lastName.state"
                    class="medium-label mb-4 required-input"
                    label-for="lastName-input">
                    <b-form-input
                      id="lastName-input"
                      v-model="form.lastName.value"
                      :state="form.lastName.state"
                      maxlength="250"
                      required
                      tabindex="6"
                      type="text"
                      v-on:change="removeInvalidFeedback('lastName'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.firstName.invalidFeedback"
                    :label="$t('structure.firstName')"
                    :state="form.firstName.state"
                    class="medium-label mb-4 required-input"
                    label-for="firstName-input">
                    <b-form-input
                      id="firstName-input"
                      v-model="form.firstName.value"
                      :state="form.firstName.state"
                      maxlength="250"
                      required
                      tabindex="7"
                      type="text"
                      v-on:change="removeInvalidFeedback('firstName'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.username.invalidFeedback"
                    :label="$t('structure.username')"
                    :state="form.username.state"
                    class="medium-label mb-4 required-input"
                    label-for="username-input">
                    <b-form-input
                      id="username-input"
                      v-model="form.username.value"
                      :state="form.username.state"
                      required
                      tabindex="8"
                      type="email"
                      v-on:change="removeInvalidFeedback('username'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.phoneNumber.invalidFeedback"
                    :label="$t('structure.phoneNumber')"
                    :state="form.phoneNumber.state"
                    class="medium-label mb-4 required-input"
                    label-for="phoneNumber-input">
                    <vue-phone-number-input
                      id="phone-input"
                      v-model="form.phoneNumber.inputValue"
                      :error="form.phoneNumber.error"
                      tabindex="9"
                      required
                      @update="checkPhone"/>
                  </b-form-group>
                </div>
              </div>

              <!--              <div class="row">-->
<!--                <div class="col-md-6">-->
<!--                  <password-creation-field :isEdit="false" :minLength="8"  :tab-index="12"-->
<!--                                           @passwordInfos="handlePasswordInfos"></password-creation-field>-->
<!--                </div>-->
<!--              </div>-->

              <div class="d-flex justify-content-end">
                <b-button tabindex="10" type="submit" variant="primary">{{ structureId ? $t('Modify') : $t('Add')+' '+$t('l.e')+' '+$t('structure')}}</b-button>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </b-container>

    <user-already-exist></user-already-exist>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import DateField from '../../components/b122/editFields/DateField'
import PasswordCreationField from '../../components/b122/editFields/PasswordCreationField'
import UserAlreadyExist from '../user/UserAlreadyExist'
import {bus} from '../../main'

export default {

  name: 'StructureCreateEdit',

  components: {
    BackArrow,
    DateField,
    PasswordCreationField,
    UserAlreadyExist
  },

  data () {
    return {
      structureId: this.$route.params.structureId,
      askConfirm: false,
      form: {
        firstName:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        lastName:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        username:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        phoneNumber:
          {
            state: null,
            invalidFeedback: null,
            error: null,
            value: null,
            inputValue: null
          },
        // password:
        //   {
        //     state: null,
        //     invalidFeedback: null,
        //     value: null
        //   },
        structureName:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        address:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        addressDetails:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        postalCode:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        city:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      },
      structure: {},
      showPassword: true
    }
  },

  mounted () {
    this.fetchData()
  },
  created () {
    bus.$on('handleSubmit', this.submitCreateEdit)
  },

  beforeDestroy () {
    bus.$off('handleSubmit', this.submitCreateEdit)
  },

  methods: {

    async fetchData () {
      if (this.structureId) {
        await this.fetchStructure()
      }
    },

    async fetchStructure () {
      api
        .get('/structure/' + this.structureId)
        .then(response => {
          this.structure = response.data
          if (this.structure.isDefaultStructure) {
            this.$router.push({
              name: 'StructureIndex'
            },
            () => {
              this.$nextTick(() => {
                this.$bvToast.toast(this.$i18n.t('unauthorized.error'), {
                  title: this.$i18n.t('Error.title'),
                  autoHideDelay: 4000,
                  toaster: 'b-toaster-bottom-right',
                  solid: true
                })
              })
            })
          }
          this.setInitialValues()
        })
    },

    async onSubmit () {
      await this.fetchUserAlreadyExist()
    },

    async fetchUserAlreadyExist () {
      let data = new FormData()
      data.append('objectType', 'Structure')
      if (this.structure.id) {
        data.append('objectId', this.structure.id)
      }
      data.append('username', this.form.username.value)
      await api({
        method: 'post',
        url: '/user/isUserAlreadyExist',
        data: data
      })
        .then(async (response) => {
          if (response.status === 200) {
            await this.submitCreateEdit()
          } else if (response.status === 202) {
            bus.$emit('toggleModal', response.data.user)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },

    async  submitCreateEdit () {
      let data = new FormData()
      data.append('firstName', this.form.firstName.value)
      data.append('lastName', this.form.lastName.value)
      data.append('username', this.form.username.value)
      data.append('phoneNumber', this.form.phoneNumber.value.e164)
      data.append('structureName', this.form.structureName.value)
      data.append('address', this.form.address.value)
      data.append('addressDetails', this.form.addressDetails.value)
      data.append('postalCode', this.form.postalCode.value)
      data.append('city', this.form.city.value)

      let url = 'structure'
      if (this.structureId) {
        url = '/structure/' + this.structureId
      }

      await api({
        method: 'POST',
        url: url,
        data: data
      })
        .then((response) => {
          this.structure = response.data
          this.$router.push({
            name: 'StructureIndex'
          },
          () => {
            this.$nextTick(() => {
              this.successToast(this.form.structureName.value)
            })
          })
        })
        .catch((error) => {
          this.$bvModal.hide('user-already-exist-modal')
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'StructureIndex'
            })
          } else {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    setInitialValues () {
      if (this.structure != null) {
        this.form.structureName.value = this.structure.structureName
        this.form.firstName.value = this.structure.user.firstName
        this.form.lastName.value = this.structure.user.lastName
        this.form.username.value = this.structure.user.username
        this.form.phoneNumber.value = this.structure.user.phoneNumber
        this.form.phoneNumber.inputValue = this.structure.user.phoneNumber
        this.form.address.value = this.structure.address
        this.form.addressDetails.value = this.structure.addressDetails !== 'null' ? this.structure.addressDetails : null
        this.form.postalCode.value = this.structure.postalCode
        this.form.city.value = this.structure.city
      }
    },
    successToast (taskName) {
      this.$bvToast.toast(this.$i18n.t('Structure') + ' "' + taskName + '" ' + this.$i18n.t('f.registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true
      })
    },

    removeInvalidFeedback (field) {
      this.form[field]['state'] = null
    },

    checkPhone (value) {
      this.form.phoneNumber.error = false
      this.form.phoneNumber.value = value
      this.removeInvalidFeedback('phoneNumber')
      this.askConfirm = true
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/structure/StructureCreateEdit.vue